import React from "react";
import styled from "styled-components";
import aboutImage from "./about.jpg";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

const Date = styled.div`
  position: absolute;
  right: 15px;
  padding: 10px 10px 10px 10px;
  color: white;
  top: 0;
  margin: -10px 10px 10px 10px;
  padding-bottom: 5px;
  background: orange;
  border-radius: 5px;
`;

const Day = styled.span`
  display: block;
  font-size: 40px;
`;
const Button = styled.button`
  color: white;
  text-transform: uppercase;
  font-size: 12px;
  background: #4b5f78;
  font-family: "Roboto", sans-serif;
  line-height: 42px;
  padding: 0 36px;
  margin-bottom: 10px;
  font-weight: 500;
  border-radius: 10px;
  border: 0px;
`;
export default function ExamSection() {
  return (
    <section className="about-area section-gap">
      <div className="container">
        <div className="text-center mb-70">
          <h1>Upcoming Exam</h1>
          <Grid>
            <div className="col1" />
            <div
              className="item1"
              style={{
                border: "none",
                background: "white",
                margin: "20px auto 0"
              }}
            >
              <img
                src={aboutImage}
                alt=""
                style={{
                  borderRadius: "10px 10px 0 0",
                  width: "100%",
                  height: "150px",
                  objectFit: "cover"
                }}
              />
              <Date>
                <Day className="day">26</Day>
                <span className="month">Jestha</span>
              </Date>
              <div
                className="examcontent"
                style={{
                  borderRadius: "0 0 10px 10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                  marginTop: "-10px"
                }}
              >
                <h2>NMCLE Model Entrance Examination</h2>
                <p>5:00 PM - 8:00 PM</p>
                <Button>Register Now</Button>
              </div>
            </div>
          </Grid>
        </div>
      </div>
    </section>
  );
}
